import config from 'Cloud/config';
import { extInfo } from 'lib/extInfo';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { CloudFile, EStorageType } from 'reactApp/modules/storage/storage.types';

import { Editor, EditorState, Extension } from '../editor.types';

/**
 * Есть стойкое ощущение, что всё, что здесь было написано и после вынесено в отдельные методы уже
 * запрограмированно в модулях compose-*
 * Нужно бы разобраться с этим и отрефачить, дабы уменьшить энтропию
 */

const ITEM_WITHOUT_HASH_MAX_SIZE = config.get('ITEM_WITHOUT_HASH_MAX_SIZE');

export const isValidEditableItem = (item: CloudFile | null | undefined): boolean => {
    if (!item) {
        return false;
    }

    const { size, ext, storage } = item;

    if (typeof size !== 'number' || !Number.isFinite(size) || size <= 0 || size <= ITEM_WITHOUT_HASH_MAX_SIZE) {
        // для файлов без размера или бесконечного размера или вдруг файлов размером
        // меньше 21 байта просмотр недоступен
        return false;
    }

    const extData = extInfo.get(ext);
    const maxSize = extData.maxEditableSize;

    if (!maxSize || (typeof maxSize === 'number' && size > maxSize)) {
        return false;
    }

    const { home, feed, attaches, viewerAttaches, favorites, search } = EStorageType;
    const notInEditableStorage = [home, feed, attaches, viewerAttaches, favorites, search].every(
        (targetStorage) => targetStorage !== storage
    );
    return !notInEditableStorage;
};

export const getAvailableEditorsForItem = (
    item: CloudFile,
    editor: EditorState,
    folderState: ReturnType<typeof isMountedOrSharedFolder>
): Editor[] => {
    const { extensions, availableEditors, sharedExtensions } = editor;
    const hasSharedEditor = editor.hasSharedEditor && sharedExtensions[item.ext];
    const isSharedFolder = hasSharedEditor || folderState.is;
    const editors = extensions[(IS_ONPREMISE && item.ext ? item.ext.toLowerCase() : item.ext) as Extension]?.editors || [];

    return editors.reduce<Editor[]>((acc, id) => {
        let editor = availableEditors[id];
        const isDefault = hasSharedEditor && isSharedFolder ? editor.default === 'shared-folder' : !!editor.default;

        if (!hasSharedEditor || !editor['x-in-shared-folder'] || isSharedFolder) {
            editor = Object.assign(
                {},
                editor,
                {
                    icon: editor.icon ? editor.icon[item.ext] : undefined,
                    icon_big: editor.icon_big[item.ext],
                },
                {
                    name: editor.id,
                    text: editor.title,
                }
            );

            if (isDefault) {
                // default is always first
                acc.unshift(editor);
            } else {
                acc.push(editor);
            }
        }
        return acc;
    }, []);
};
